import { Injectable } from '@angular/core';
import { FcpModalService } from 'fc-ui-components';
import { Subject } from 'rxjs';

const modalId = 'prevent-navigation-modal';

@Injectable({ providedIn: 'root' })
export class PreventNavigationService {
    private navigationIsNotPrevented: Subject<boolean> = new Subject<boolean>();

    constructor(private fcpModalService: FcpModalService) {}

    public displayModal() {
        this.fcpModalService.open(modalId);
    }

    public hideModal() {
        this.fcpModalService.close(modalId);
    }

    public preventNavigation() {
        this.navigationIsNotPrevented.next(false);
    }

    public allowNavigation() {
        this.navigationIsNotPrevented.next(true);
    }

    public get preventNavigationStatus() {
        return this.navigationIsNotPrevented;
    }
}
